import { Card, Grid, styled, useTheme } from '@mui/material';
import { Fragment, useState } from 'react';
import Campaigns from './shared/Campaigns';
import DoughnutChart from './shared/Doughnut';
import RowCards from './shared/RowCards';
import StatCards from './shared/StatCards';
import StatCards2 from './shared/StatCards2';
import TopSellingTable from './shared/TopSellingTable';
import UpgradeCard from './shared/UpgradeCard';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import DoughnutChartBooking from './shared/DoughnutChartBooking';
import LastBooking from './shared/LastBooking';
import {
	productAjaxDispatch,
	showcustomerDispatch,
	showOrderDispatch,
	showProductDispatch,
} from '../../../reducers/HomeReducer';
import './dash.css';
import NewOrderModal from 'app/components/NewOrderModal';
import { addCartRowNew, removeSelectedCartNew } from 'reducers/UiReducer';

const ContentBox = styled('div')(({ theme }) => ({
	margin: '30px',
	[theme.breakpoints.down('sm')]: { margin: '16px' },
}));

const Title = styled('span')(() => ({
	fontSize: '1rem',
	fontWeight: '500',
	marginRight: '.5rem',
	textTransform: 'capitalize',
}));

const SubTitle = styled('span')(({ theme }) => ({
	fontSize: '0.875rem',
	color: theme.palette.text.secondary,
}));

const H4 = styled('h4')(({ theme }) => ({
	fontSize: '1rem',
	fontWeight: '500',
	marginBottom: '16px',
	textTransform: 'capitalize',
	color: theme.palette.text.secondary,
}));

const Shopping = () => {
	const { palette } = useTheme();
	const { loginInfo, customer, product, order, productAjax } = useSelector(
		(state) => state.home
	);
	const { cart } = useSelector((state) => state.ui);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	console.log('productAjax', productAjax);
	const [isClicked, setIsClicked] = useState(false);
	useEffect(() => {
		let form = {
			keywords: '',
			limits: 100,
		};
		dispatch(productAjaxDispatch(form));
		dispatch(showProductDispatch());
	}, []);
	return (
		<>
			<div
				clasName='page ps'
				style={{
					maxHeight: '100vh',
					overflowY: 'auto',
					overflowX: 'hidden',
					scrollbarWidth: 'thin',
					scrollbarColor: '#888 #f5f5f5',
					padding: 20,
				}}>
				<Grid container>
					{productAjax?.result?.map((i) => {
						return (
							<Grid item xs={12} lg={3}>
								<div className='wrapper'>
									<div
										className='container'
										style={{
											backgroundImage: `url(${i.imgpath})`,
											backgroundRepeat: 'no-repeat',
											backgroundPosition: 'center center',
											backgroundSize: 'cover',
											position: 'relative', // Added for positioning the overlay
										}}>
										{/* Out of Stock Overlay */}
										{i.total_quantity <
											Number(i.min_order) * Number(i.set_quantity) && (
											<div
												style={{
													position: 'absolute',
													top: 0,
													left: 0,
													right: 0,
													bottom: 0,
													backgroundColor: 'rgba(0, 0, 0, 0.5)',
													display: 'flex',
													alignItems: 'center',
													justifyContent: 'center',
													color: 'white',
													fontSize: '1.5rem',
													fontWeight: 'bold',
													textTransform: 'uppercase',
												}}>
												Out of Stock
											</div>
										)}

										<div className='top'></div>
										{i.total_quantity <
										Number(i.min_order) * Number(i.set_quantity) ? (
											''
										) : (
											<div
												className={
													cart?.some((obj) => obj.id === i.id)
														? 'bottom clicked'
														: 'bottom'
												}>
												<div className='left'>
													<div className='details'>
														<h6 style={{ textTransform: 'capitalize' }}>
															{i.name}
														</h6>
														<p style={{ fontWeight: 'bold' }}>₹{i.price_per}</p>
													</div>
													<div
														style={{
															cursor:
																i.total_quantity <= 0
																	? 'not-allowed'
																	: 'pointer',
														}}
														className='buy'
														onClick={() => {
															if (i.total_quantity > 0) {
																setIsClicked(true);
																dispatch(addCartRowNew(i));
															}
														}}>
														<i className='material-icons'>add_shopping_cart</i>
													</div>
												</div>
												<div className='right'>
													<div className='done'>
														<i className='material-icons'>done</i>
													</div>
													<div className='details'>
														<h6 style={{ textTransform: 'capitalize' }}>
															{i.name}
														</h6>
														<p style={{ fontWeight: 'bold' }}>₹{i.price_per}</p>
													</div>
													<div
														style={{ cursor: 'pointer' }}
														className='remove'
														onClick={() => {
															setIsClicked(false);
															dispatch(removeSelectedCartNew(i));
														}}>
														<i className='material-icons'>clear</i>
													</div>
												</div>
											</div>
										)}
									</div>
									<div className='inside'>
										<div className='icon'>
											<i className='material-icons'>info_outline</i>
										</div>
										<div className='contents'>
											<table>
												<tr>
													<th>Description</th>
													<th>{i.desc}</th>
												</tr>{' '}
												<tr>
													<th>Category</th>
													<th>{i.category_name}</th>
												</tr>{' '}
												<tr>
													<th>Minimum Order</th>
													<th>{i.min_order}</th>
												</tr>
												<tr>
													<th>Maximum Order</th>
													<th>{i.max_order}</th>
												</tr>
												<tr>
													<th>Available Stock</th>
													<th>{i.total_quantity}</th>
												</tr>
												<tr>
													<th>Set Quantity</th>
													<th>{i.set_quantity}</th>
												</tr>
											</table>
										</div>
									</div>
								</div>
							</Grid>
						);
					})}
				</Grid>
			</div>
		</>
	);
};

export default Shopping;
